import { ChevronRight, Filter as FilterIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { cn } from "~/lib/utils";

interface FilterToggleButtonProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const FilterToggleButton = ({
  isOpen,
  onToggle,
}: FilterToggleButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button variant="outline" onClick={onToggle} className="shrink-0">
      <FilterIcon />
      {t(($) => $.commons.filter.title)}
      <ChevronRight
        className={cn("transition-transform", isOpen && "rotate-90")}
      />
    </Button>
  );
};
